import { useMemo } from 'react'
import { shouldShowAverageInformation } from 'components/insightContent/Overview/DetailItems/CrosstabMeasure/utils/viewOptionUtils'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { InsightContentSettingType } from 'components/insightContent/types'
import { WidgetId } from 'features/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { InsightViewOptionStrings } from 'enums/InsightViewOption'

type UseAccordionSummaryContentsProps = {
  widgetId: WidgetId
  isAudienceQuery: boolean
  detailSetting?: InsightContentSettingType
  viewOption?: InsightViewOptionStrings
  pivot?: InsightData
}

const useAccordionSummaryContents = ({
  widgetId,
  isAudienceQuery,
  detailSetting,
  viewOption,
  pivot
}: UseAccordionSummaryContentsProps) => {
  const shouldShowAverageViewOption = useMemo(() => shouldShowAverageInformation(viewOption), [
    viewOption
  ])

  const accordionSummaryContents = useMemo(() => {
    const contents = []
    contents.push({
      insightContentType: shouldShowAverageViewOption
        ? InsightContentType.CROSSTAB_AVERAGE_MEASURE
        : InsightContentType.CROSSTAB_TOTAL_MEASURE,
      detailSetting,
      widgetId,
      isAudienceQuery
    })

    contents.push({
      insightContentType: InsightContentType.CROSSTAB_SELECTED_ITEM_MEASURE,
      detailSetting,
      widgetId,
      isAudienceQuery
    })

    if (!pivot) {
      return contents
    }

    contents.push(
      {
        insightContentType: shouldShowAverageViewOption
          ? InsightContentType.CROSSTAB_COLUMN_AVERAGE_DIFF
          : InsightContentType.CROSSTAB_SHARE_OF_COLUMNS,
        detailSetting,
        widgetId,
        isAudienceQuery
      },
      {
        insightContentType: shouldShowAverageViewOption
          ? InsightContentType.CROSSTAB_ROW_AVERAGE_DIFF
          : InsightContentType.CROSSTAB_SHARE_OF_ROWS,
        detailSetting,
        widgetId,
        isAudienceQuery
      }
    )

    return contents
  }, [widgetId, isAudienceQuery, detailSetting, pivot, shouldShowAverageViewOption])

  return accordionSummaryContents
}

export default useAccordionSummaryContents
